import clsx from 'clsx'
import { ReactNode } from 'react'

import { ProductType } from '@/ts/Product'

function Thumb(props: ThumbProps) {
  const { children, isSelected, onClick, type } = props

  return (
    <button
      onClick={onClick}
      className={clsx(
        'relative flex-shrink-0 w-[calc(25%-16px)] 2lg:w-[calc(20%-16px)] xl:w-[calc(25%-16px)] min-w-[150px] h-40 overflow-hidden rounded-lg border-4 py-2 transition-all',
        {
          'opacity-50 !border-transparent': !isSelected,
          'border-violet-55': type === 'Product::Digital',
          'border-green-100': type === 'Product::FansiClass',
          'border-green-5': type === 'Product::FansiCollection',
          'border-violet-200': type === 'Product::FansiVideo',
          'border-yellow-50': type === 'Product::FansiExperience',
        }
      )}
      type="button"
    >
      {children}
    </button>
  )
}

interface ThumbProps {
  children: ReactNode
  isSelected: boolean
  onClick(): void
  type: ProductType
}

export default Thumb
